import React from 'react';

import { useExclusions } from '../api/getExclusions';
import { useSupplierExclusions } from '../api/getSupplierExclusions';
import { useSupplierRates } from '../api/getSupplierRates';
import { useUpdateSupplierRate } from '../api/updateSupplierRate';
import { RateInputMatrices } from './RateInputMatrices';

const resource = 'framework_agreements';

export const SupplierRatesEditor = ({ id, lot, supplier, onSaved }) => {
  const { data: globalExclusions } = useExclusions(resource, id, lot.lot_id);
  const { data: supplierExclusions } = useSupplierExclusions(id, lot.lot_id, supplier.fac_id);
  const { data: rates, refetch } = useSupplierRates(id, lot.lot_id, supplier.fac_id);
  const { mutateAsync: updateRate } = useUpdateSupplierRate(id, lot.lot_id, supplier.fac_id);

  return (
    <RateInputMatrices
      resource={resource}
      id={id}
      lotId={lot.lot_id}
      rates={rates}
      exclusions={[...globalExclusions, ...supplierExclusions]}
      onSave={(roleId, levelId, rate) =>
        updateRate({ role_id: roleId, level_id: levelId, rate }).then(() =>
          Promise.all([refetch(), onSaved()])
        )
      }
    />
  );
};
